/*============================ loading google captcha ============================*/

let googleCaptchaScriptLoadingStatus = false;
window.addEventListener('scroll', function () {
	let scroll = window.scrollY;

	if (scroll > 0) {
		loadGoogleCaptchaScript();
		loadUserChatScript();
		loadCommonScripts();
		addChatBotIcon();
	}
}, true);

window.addEventListener('touchstart', function () {
	loadGoogleCaptchaScript();
	loadUserChatScript();
	loadCommonScripts();
	addChatBotIcon();
}, {passive: true});

$(function () {

	// ====================== On login Modal Shown
	$('#loginModal').on('show.bs.modal', () => {
		loadGoogleCaptchaScript();
		loadUserChatScript();
		loadCommonScripts();
		addChatBotIcon();
	});

	// ======================On assistant Modal Shown
	$('#AssistantModal').on('show.bs.modal', () => {
		loadGoogleCaptchaScript();
		loadUserChatScript();
		loadCommonScripts();
		addChatBotIcon();
	});

	// ======================wishlist modal shown
	$('#ShortlistModal').on('show.bs.modal', () => {
		loadGoogleCaptchaScript();
		loadUserChatScript();
		loadCommonScripts();
		addChatBotIcon();
	});

	// ======================requestCallBack
	$('#requestCallBack').on('show.bs.modal', () => {
		loadGoogleCaptchaScript();
		loadUserChatScript();
		loadCommonScripts();
		addChatBotIcon();
	});

	//======================= On contact or registration page
	if (pageType !== 'undefined') {
		if (['CONTACT', 'REGISTRATION', 'THANK_YOU', 'PAID_COUNSELLING', 'PARENT_ASSISTANT_PAGE'].includes(pageType)) {
			loadGoogleCaptchaScript();
			loadUserChatScript();
			loadCommonScripts();
			addChatBotIcon();
		}
	}
});

/*============================ /loading google captcha ============================*/

async function loadGoogleCaptchaScript() {
	let scriptLoaded = '';
	if (googleCaptchaScriptLoadingStatus === false) {
		googleCaptchaScriptLoadingStatus = true;

		scriptLoaded = await lazyLoadThisScript('body', [
			{
				"src": "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
				"async": 1,
				"defer": 1
			},
		], 'last', 100);
	}
}

let userChatScriptLoadingStatus = false;

async function loadUserChatScript() {
	let scriptLoaded = '';
	if (userChatScriptLoadingStatus === false) {
		userChatScriptLoadingStatus = true;
		scriptLoaded = await lazyLoadThisScript('body', [
			{"src": `${window.location.origin}/common/js/badWords.js`}
			/*{"src": `${window.location.origin}/common/js/intlTelInput-jquery.min.js`}*/
		], 'last', 100);
	}
}

let commonScriptsLoadingStatus = false;

async function loadCommonScripts() {
	let styleLoaded = '';
	if (commonScriptsLoadingStatus === false) {
		commonScriptsLoadingStatus = true;

		styleLoaded = await lazyLoadCss([
			`${window.location.origin}/assets/build/Assistant.css`,
			`${window.location.origin}/common/css/intlTelInput.min.css`,
			// `${window.location.origin}/assets/fontawesome/css/font-awesome.min.css`,

		], 'last', 100);

	}
}

function handleTouchStart() {
	loadScriptsChunk()
	document.removeEventListener("touchstart", handleTouchStart);
}

function handleScroll() {
	if (window.scrollY > 0) {
		loadScriptsChunk()
		window.removeEventListener("scroll", handleScroll);
	}
}

function handleMouseMove(event) {
	loadScriptsChunk();
	document.removeEventListener("mousemove", handleMouseMove);
}

let loadingScriptStatus = false;

async function loadScriptsChunk() {
	if (loadingScriptStatus) return;

	loadingScriptStatus = true;

	await lazyLoadCss([
		`${window.location.origin}/home-page/assets/css/slick-theme.css`,
		`${window.location.origin}/home-page/assets/css/slick.css`,
	], 'last', 100);

}


/*--------EdustokeAI Common Google Event Function - Start--------*/
function AiGtagEvent(name = '', label = '') {
	console.log(`Event : ${name} - ${label}`);
	gtag("event", name, {
		event_category: "EdustokeAi",
		event_label: label ?? name
	});
}

/*--------EdustokeAI Common Google Event Function - END--------*/

/*-------- Load Edustoke AI gif --------*/
let isAIGifLoaded = false;
function addChatBotIcon() {
	if(isAIGifLoaded === false){
		let container = document.getElementById("chatBotGifContainer");
		if(!!container){
			container.innerHTML = `<img id="chatBotIcon"
                 src="${HOST}/assets/images/eduAiBtn.gif"
                 class="lazyload"
                 alt="Edustoke AI"
                 width="160"
                 height="160"
                 data-toggle="tooltip"
                 data-placement="top"
                 title="EdustokeAI - School Searching AI">`;

			$('[data-toggle="tooltip"]').tooltip();
			isAIGifLoaded = true;
		}
	}
}
/*-------- /Load Edustoke AI gif --------*/
